import { useEffect, useState } from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
const WeeklyPracticeGoal = ({ adviseData }) => {
  const [open, setOpen] = useState(false);
  const markAsDoneCount = adviseData?.filter(
    (item) => item?.mark_as_done
  )?.length;
  const { t } = useTranslation();
  return (
    <div
      className="bg-white shadow-lg p-6 rounded-lg w-full max-w-full bg-cover mt-3"
      style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
        <p className="text-[16px] font-[Lato] font-[600] text-[#fff] text-center">
          {t("mindfulnessCoachPreferences.You’ve completed")} {markAsDoneCount}{" "}
          {t("mindfulnessCoachPreferences.of")} {adviseData?.length}
        </p>
         <p className="text-[14px] font-[Lato] text-white">
          {adviseData?.length}{" "}
          {t("mindfulnessCoachPreferences.practices this week")}
        </p>
        {/* <button
          onClick={() =>
            subscription?.status === "active" || subscription?.status === "pending-cancel"
              ? navigate("/mindfulness-preferences", {
                  state: { mindfulness: true },
                })
              : navigate("/renew-subscription")
          }
          className={`px-[20px] py-[10px] bg-[white] text-[#0575e6] rounded-[100px] text-[12px] `}
        >
          Update Preferences
        </button> */}
      </div>
      <div className="border rounded-lg p-2 bg-white font-[Lato]">
        {/* <div className="flex justify-center">
          <button
            disabled
            className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-[22px] py-2 px-3 text-[14px] my-2 text-white"
          >
            {t("mindfulnessCoachPreferences.Your Goal")}
          </button>
        </div> */}
       
        <div className="flex justify-center items-center gap-1 md:gap-4">
          {adviseData?.map((item, index) => {
            return item?.mark_as_done ? (
              // <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] w-5 h-5 rounded-full flex items-center justify-center">
              //   <div className="bg-white w-3 h-3 rounded-full"></div>
              // </div>

              (<div
                className={`rounded-full bg-[#36F136] flex-1 h-3`}
              >
                {/* <span className="text-white text-md">✓</span> */}
              </div>)
            ) : (
              <div className="bg-[#E6E6E6] rounded-full flex-1 h-3"></div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WeeklyPracticeGoal;
